import React from "react";
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Get version from package.json to bust cache
const appVersion = process.env.REACT_APP_VERSION || '2.3.4';

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${appVersion}`,
        },
    });

export default i18next;
